(() => {
  'use strict';
  const instances = new WeakMap();
  function init(section) {
    if (!section || instances.has(section)) return instances.get(section) || null;
    const script = section.querySelector('[data-open-complement-config]');
    if (!script) return null;
    let data;
    try { data = JSON.parse(script.textContent); } catch (_) { return null; }
    const find = selector => section.querySelector(selector);
    const toggles = { mat: find('[data-addon="mat"]'), bags: find('[data-addon="bags"]') };
    const size = find('[data-addon-size]'), colour = find('[data-addon-colour]'), lot = find('[data-addon-lot]');
    const quantity = find('[data-addon-quantity="bags"]'), minus = find('[data-addon-minus="bags"]'), plus = find('[data-addon-plus="bags"]');
    if (!toggles.mat || !toggles.bags || !size || !colour || !lot || !quantity || !minus || !plus) return null;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: section.dataset.currency || 'EUR' });
    let busy = false;
    const current = kind => kind === 'mat'
      ? data.mat.variants.find(variant => variant.size === size.value && variant.color === colour.value)
      : data.bags.variants.find(variant => String(variant.id) === lot.value);
    const maximum = variant => Math.max(0, Math.floor(Number(variant?.maxQuantity) || 0));
    const available = variant => Boolean(variant && variant.available !== false && maximum(variant) > 0 && Number(variant.priceCents) > 0);
    const count = () => Math.min(Math.max(1, Math.floor(Number(quantity.value) || 1)), Math.max(1, maximum(current('bags'))));
    function getState() {
      const items = ['mat', 'bags'].filter(kind => toggles[kind].checked).map(kind => {
        const variant = current(kind);
        return {
          id: variant?.id || '',
          quantity: kind === 'bags' ? count() : 1,
          priceCents: Number(variant?.priceCents) || 0,
          available: available(variant),
          maxQuantity: maximum(variant),
          kind,
          variantTitle: variant?.title || '',
          image: variant?.image || ''
        };
      });
      return { items, totalCents: items.reduce((sum, item) => sum + item.priceCents * item.quantity, 0), canAdd: items.every(item => item.available && item.quantity <= item.maxQuantity) };
    }
    function paint(notify = false) {
      const bagCount = count(), max = maximum(current('bags'));
      quantity.value = String(bagCount);
      quantity.max = String(Math.max(1, max));
      ['mat', 'bags'].forEach(kind => {
        const variant = current(kind), isAvailable = available(variant);
        const card = find('[data-addon-card="' + kind + '"]');
        card.classList.toggle('is-selected', toggles[kind].checked);
        toggles[kind].disabled = busy || (!isAvailable && !toggles[kind].checked);
        const price = find('[data-addon-price="' + kind + '"]');
        price.textContent = '+ ' + formatter.format((Number(variant?.priceCents) || 0) * (kind === 'bags' ? bagCount : 1) / 100);
        const image = find('[data-addon-image="' + kind + '"]');
        if (variant?.image && image.getAttribute('src') !== variant.image) image.src = variant.image;
        if (kind === 'mat') image.alt = 'Tapis de litière ' + colour.value.toLowerCase();
        const feedback = card.querySelector('.cocon-addon-feedback');
        feedback.hidden = isAvailable;
        feedback.textContent = isAvailable ? '' : kind === 'mat' ? 'Ce tapis est indisponible pour le moment.' : 'Sacs indisponibles pour le moment.';
      });
      Array.from(size.options).forEach(option => { option.disabled = !data.mat.variants.some(variant => variant.size === option.value && variant.color === colour.value && available(variant)); });
      Array.from(colour.options).forEach(option => { option.disabled = !data.mat.variants.some(variant => variant.color === option.value && variant.size === size.value && available(variant)); });
      Array.from(lot.options).forEach(option => { option.disabled = !available(data.bags.variants.find(variant => String(variant.id) === option.value)); });
      size.disabled = colour.disabled = lot.disabled = busy;
      quantity.disabled = busy || !available(current('bags'));
      minus.disabled = busy || !available(current('bags')) || bagCount <= 1;
      plus.disabled = busy || !available(current('bags')) || bagCount >= max;
      section.setAttribute('aria-busy', String(busy));
      if (notify) document.dispatchEvent(new CustomEvent('cocon:purchase-complement-changed', { detail: getState() }));
    }
    section.addEventListener('change', () => paint(true));
    quantity.addEventListener('input', () => { if (quantity.value !== '') paint(true); });
    minus.addEventListener('click', () => { quantity.value = String(count() - 1); paint(true); });
    plus.addEventListener('click', () => { quantity.value = String(count() + 1); paint(true); });
    document.addEventListener('cocon:purchase-busy', event => { busy = Boolean(event.detail?.busy); paint(); });
    const api = { getState, refresh: () => paint(true) };
    instances.set(section, api);
    section.hidden = false;
    paint(true);
    return api;
  }
  const initAll = scope => scope.querySelectorAll('[data-cocon-open-complements]').forEach(init);
  window.CoconOpenComplements = { init, get: root => instances.get(root) || null, initAll };
  initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
